import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
export const fetchObjectTypeDefinitions = async () => {
  const results = await getFrameworkDataSchemasClient().then(client => client.frameworkTypes.getObjects());
  return results;
};